/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen update!!!

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Joseph Diphoko",
  title: "Hi, I'm Joseph",
  subTitle: emoji(
    "A passionate Accountant 🔢 and Hobbyist Developer 💻 experienced in financial analysis, public auditing and applications with python (native + other interesting libraries and frameworks)."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1qTl8mtIeYtLPbMFQNtr3QzU_JYfCrThz/view?usp=drive_link", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "",
  linkedin: "www.linkedin.com/in/joseph-diphoko",
  gmail: "joedphk@gmail.com",
  gitlab: "",
  facebook: "",
  medium: "",
  stackoverflow: "",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Which skills do I possess?",
  subTitle: "Erudite...who wants to innovate.",
  skills: [
    emoji(
      "🟡Analysis of financial statements (including the balance sheet, income statement, and notes to the financial statements. To ensure accuracy and compliance with accounting standards and internal controls)."
    ),
    emoji("🟡Evaluation of financial compliance in all aspects of business operations, including financial reporting, budgeting, forecasting, and transaction processing."),
    emoji(
      "🟡BPNM 2.0 Process Modeling."
    ),
    emoji(
      "🟡Proficient in verbal and written communication."
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "excel",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "aws/oracle",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "flet",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "SQL/pandas/polars",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "University of The Free State",
      logo: require("./assets/images/ufslogo.jpg"),
      subHeader: "Bachelor of Commerce in Accounting",
      duration: "February 2016- April 2020",
      desc: "Ranked top 15%:",
      descBullets: [
        "Financial Accounting",
        "Taxation",
        "Management Accounting"
      ]
    },
    {
      schoolName: "University of The Free State",
      logo: require("./assets/images/ufslogo.jpg"),
      subHeader: "Bachelor of Commerce (Honours) Management Accounting",
      duration: "February 2020- April 2021",
      desc: "Top ranked Dissertation: Global pandemic effects on an entity's listed price",
      descBullets: [
        "Research and research methodology",
        "Enterprise management",
        "Financial Management",
        "Performance Management"
      ]
    },
    {
      schoolName: "Chartered Institute of Management Accountants",
      logo: require("./assets/images/aicpalogo.jpg"),
      subHeader: "Advanced Diploma in Management Accounting",
      duration: "February 2021- June 2023",
      desc: "Focus:",
      descBullets: [
        "Advanced Management Accounting",
        "Advanced Financial Reporting",
        "Advanced Performance Management"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Excel",
      progressPercentage: "79%"
    },
    {
      Stack: "Frontend Programming",
      progressPercentage: "55%"
    },
    {
      Stack: "Backend Programming",
      progressPercentage: "65%"
    },
    {
      Stack: "Strategic analysis",
      progressPercentage: "83%"
    },
    {
      Stack: "Managing deadlines", //Insert stack or technology you have experience in
      progressPercentage: "89%" //Insert relative proficiency in percentage
    },
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Financial / Systems Analyst",
      company: "First National Bank",
      companylogo: require("./assets/images/FNB.png"),
      date: "January 2025 – Present",
      descBullets: [
        "I assisted clients in designing and migrating from manual reconciliation processes to automated solutions using SQL and Assure by Precisely, enhancing data integrity, operational efficiency and financial controls.",
      ]
    },
    {
      role: "Audit Assistant",
      company: "Deloitte",
      companylogo: require("./assets/images/deloitte-logo.png"),
      date: "Februay 2024 – July 2024",
      desc: "Client: Eskom Finance Company (SOC) Ltd and Nqaba Finance 1 (RF) Ltd.",
      descBullets: [
        "I reviewed financial statements to ensure accuracy and compliance with accounting standards and internal controls.",
      ]
    },
    {
      role: "Audit Assistant",
      company: "Tholisiwe",
      companylogo: require("./assets/images/Tholisiwe.png"),
      date: "Februay 2024 – July 2024",
      desc: "Client: Goldplat Recovery (Pty) Ltd.                                 ",
      descBullets: [
        "I evaluated the effectiveness of internal controls and ensured compliance with regulatory requirements, and company policies.",
      ]
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume/CV",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Do you have any interesting opportunities or projects? My Inbox is open for all.",
  email_address: "joedphk@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
